import { useRef } from "react";
import { Flex, Spin } from "antd";
import { PrinterOutlined, LeftOutlined } from "@ant-design/icons";
import Button from "@/common/elements/Button";
import { StyledDarkSectionTitle } from "@/common/styles";
import {
  ReportSectionList,
  ReportBioHeader,
  useJacketReportSections,
  mapDistinguishingCharacteristics,
  buildJacketReportPrintHtml,
} from "./JacketReportSections";
import {
  SummaryWrapper,
  SummaryHeaderBar,
  ReportSectionsWrapper,
} from "./styles";

// Full "Jacket Summary Report" — the React rebuild of reports/
// JacketSummaryNew.asp, opened from Super Search by clicking a jacket
// result. Renders as one continuous scrollable document, same as the ASP
// popup (which is a single HTML table top to bottom, not separate pages).
// The bio header, section list, and data-fetching are all shared with
// BookingSummaryReport/WarrantSummaryReport via JacketReportSections.jsx —
// see that file for why (ASP opens this same report from every module).
const JacketFullSummaryReport = ({ row, onBack, onClose }) => {
  const printRef = useRef();
  const jacketId = row?.folderId;
  const bio = row?.originalData?.jackets?.bio?.[0] || {};

  const { loading, sectionRows: fetchedSectionRows } =
    useJacketReportSections(jacketId);
  const sectionRows = {
    ...fetchedSectionRows,
    distinguishingCharacteristics: mapDistinguishingCharacteristics(
      bio?.distinguishingCharacteristics,
    ),
  };

  const handlePrint = () => {
    const reportContent = printRef.current;
    if (!reportContent) return;

    const printWindow = window.open("", "", "width=900,height=1000");
    printWindow.document.write(
      buildJacketReportPrintHtml(
        `Jacket Summary Report — Folder ID ${jacketId}`,
        reportContent.innerHTML,
      ),
    );
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <SummaryWrapper>
      <SummaryHeaderBar justify="space-between" align="center">
        <Flex align="center" gap="small">
          <Button icon={<LeftOutlined />} onClick={onBack}>
            Back to Results
          </Button>
          <StyledDarkSectionTitle as="span">
            Jacket Summary Report — Folder ID {jacketId}
          </StyledDarkSectionTitle>
        </Flex>
        <Flex gap="small">
          <Button
            color="primary"
            type="primary"
            variant="solid"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
          >
            Print
          </Button>
          <Button onClick={onClose}>Close</Button>
        </Flex>
      </SummaryHeaderBar>

      <Spin spinning={loading}>
        <div ref={printRef} className="report-content">
          <ReportSectionsWrapper>
            <ReportBioHeader bio={bio} jacketId={jacketId} />

            <ReportSectionList sectionRows={sectionRows} />
          </ReportSectionsWrapper>
        </div>
      </Spin>
    </SummaryWrapper>
  );
};

export default JacketFullSummaryReport;
